import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import PatentContentContext from './PatentContentContext';

function CitedByWrapper({ children }) {
  const { document, updatedCitedByUrl, getTrackingAttrs } = useContext(PatentContentContext);
  const { issueCitedByCounter } = document;
  const shouldDisplayCitedBy = issueCitedByCounter > 0;

  return (
    <div className="patent-content__flex-row">
      {children}
      {shouldDisplayCitedBy && (
        <a
          data-e2e="patent-cited-count"
          className="els-btn els-btn-link blue-compact--underline els-btn-xs e2e-cited-count rx-element-cited-count"
          target="_blank"
          href={updatedCitedByUrl}
          {...getTrackingAttrs(
            {
              'data-tracking-type': 'linkout',
              'data-tracking-action': 'cited',
            },
            true
          )}>
          Cited {issueCitedByCounter} times
        </a>
      )}
    </div>
  );
}

CitedByWrapper.propTypes = {
  children: PropTypes.node,
};

export default CitedByWrapper;
